/* ============================================================
   FootyFits Certificate Builder — recolour (2 colours), crest + photo upload,
   editable wording, exported as a 2-page (front + back) A4 landscape print-ready PDF.
   ============================================================ */
(function(){
  "use strict";
  function $(id){ return document.getElementById(id); }
  var root = $("cb-root"); if(!root) return;

  var DATA = { variants: [] };
  try{ DATA = JSON.parse($("cb-data").textContent); }catch(e){ DATA = { variants: [] }; }

  var PRESETS = [
    ["#16365e","#e6b422"],["#7a1f2b","#f0c040"],["#0a7a3f","#ffffff"],["#e02128","#101010"],
    ["#1b3a8c","#e02128"],["#101010","#f5c518"],["#5b2a86","#f0c040"],["#0a7a3f","#e6b422"],
    ["#00539f","#ffffff"],["#111111","#e02128"]
  ];

  var S = { crest:null, bgUrl:null, bgUpload:null };
  // pick up a customizer default background (inline style set in liquid)
  (function(){ var el=$("cert-photo"); if(el && el.style.backgroundImage && el.style.backgroundImage!=="none"){ var m=/url\(["']?(.*?)["']?\)/.exec(el.style.backgroundImage); if(m) S.bgUrl=m[1]; } })();

  /* ---------- colours ---------- */
  function setCol(n, hex){ root.style.setProperty("--c"+n, hex); }
  function onColour(id, n){ var e=$(id); if(!e) return; e.addEventListener("input", function(){ setCol(n, this.value); }); }
  onColour("cb-col1", 1); onColour("cb-col2", 2);
  (function buildPresets(){
    var host=$("cb-presetcols"); if(!host) return;
    PRESETS.forEach(function(p){
      var b=document.createElement("button"); b.type="button"; b.title=p[0]+" / "+p[1];
      b.innerHTML='<i style="background:'+p[0]+'"></i><i style="background:'+p[1]+'"></i>';
      b.addEventListener("click", function(){
        setCol(1,p[0]); setCol(2,p[1]);
        if($("cb-col1")) $("cb-col1").value=p[0]; if($("cb-col2")) $("cb-col2").value=p[1];
      });
      host.appendChild(b);
    });
  })();

  /* ---------- wording ---------- */
  function bindText(inputId, targetIds){
    var e=$(inputId); if(!e) return;
    function apply(){ targetIds.forEach(function(t){ var el=$(t); if(el) el.textContent = e.value || el.getAttribute("data-empty") || ""; }); }
    e.addEventListener("input", apply); apply();
  }
  bindText("cb-i-heading", ["cert-heading"]);   // front only — the back has no text
  bindText("cb-i-name", ["cert-name"]);
  bindText("cb-i-recog", ["cert-recog"]);
  bindText("cb-i-date", ["cert-date"]);
  bindText("cb-i-message", ["cert-message"]);

  /* ---------- background removal (transparency + 4-corner edge flood-fill) ---------- */
  function removeBackground(imgEl, done){
    var W=imgEl.naturalWidth, H=imgEl.naturalHeight; if(!W||!H){ done(null,"unreadable"); return; }
    var scale=Math.min(1,900/Math.max(W,H)), w=Math.max(1,Math.round(W*scale)), h=Math.max(1,Math.round(H*scale));
    var c=document.createElement("canvas"); c.width=w; c.height=h; var ctx=c.getContext("2d"); ctx.drawImage(imgEl,0,0,w,h);
    var id,d; try{ id=ctx.getImageData(0,0,w,h); d=id.data; }catch(e){ done(null,"unreadable"); return; }
    var trans=0; for(var i=3;i<d.length;i+=4){ if(d[i]<250) trans++; } if(trans>w*h*0.02){ done(null,"already"); return; }
    function at(x,y){ var o=(y*w+x)*4; return [d[o],d[o+1],d[o+2]]; }
    var corners=[at(0,0),at(w-1,0),at(0,h-1),at(w-1,h-1)], avg=[0,0,0];
    corners.forEach(function(c2){ avg[0]+=c2[0];avg[1]+=c2[1];avg[2]+=c2[2]; }); avg=[avg[0]/4,avg[1]/4,avg[2]/4];
    var agree=corners.every(function(c2){ return Math.abs(c2[0]-avg[0])<32&&Math.abs(c2[1]-avg[1])<32&&Math.abs(c2[2]-avg[2])<32; });
    if(!agree){ done(null,"nocorner"); return; }
    var tol=48, visited=new Uint8Array(w*h), stack=[];
    for(var x=0;x<w;x++){ stack.push(x); stack.push((h-1)*w+x); }
    for(var y=0;y<h;y++){ stack.push(y*w); stack.push(y*w+(w-1)); }
    function matches(o){ return Math.abs(d[o]-avg[0])<tol&&Math.abs(d[o+1]-avg[1])<tol&&Math.abs(d[o+2]-avg[2])<tol; }
    while(stack.length){ var idx=stack.pop(); if(idx<0||idx>=w*h||visited[idx]) continue; visited[idx]=1; var o=idx*4;
      if(!matches(o)) continue; d[o+3]=0; var px=idx%w; if(px>0)stack.push(idx-1); if(px<w-1)stack.push(idx+1); stack.push(idx-w); stack.push(idx+w); }
    ctx.putImageData(id,0,0); done(c.toDataURL("image/png"),"flood");
  }

  /* ---------- crest ---------- */
  function crestSrc(){ return S.crest ? (S.crest.processedUrl||S.crest.url) : null; }
  function renderCrest(){
    var src=crestSrc();
    [["cert-crest"],["cert-crest-b"]].forEach(function(pair){
      var host=$(pair[0]); if(!host) return;
      if(src){ host.innerHTML='<img alt="">'; host.querySelector("img").src=src; }
      else { host.innerHTML='<div class="cert-crest-ph">Your crest</div>'; }
    });
    var chip=$("cb-crestchip"); if(chip) chip.classList.toggle("cb-hidden", !S.crest);
    var bgrow=$("cb-crestbgrow"); if(bgrow) bgrow.classList.toggle("cb-hidden", !S.crest);
    if(S.crest){ var th=$("cb-crestthumb"); if(th) th.src=src; var nm=$("cb-crestname"); if(nm) nm.textContent=S.crest.name||"Crest"; }
  }
  $("cb-crestfile").addEventListener("change", function(){
    var f=this.files&&this.files[0]; if(!f) return;
    // read as a data: URL (not a blob: object URL) — data URLs render reliably in html2canvas across all browsers
    var reader=new FileReader();
    reader.onload=function(){
      S.crest={ name:f.name, url:reader.result, file:f, processedUrl:null };
      var msg=$("cb-crestbgmsg"); if(msg) msg.textContent=""; var undo=$("cb-crestundo"); if(undo) undo.classList.add("cb-hidden");
      renderCrest();
    };
    reader.readAsDataURL(f);
  });
  $("cb-crestremove").addEventListener("click", function(){ if(S.crest&&S.crest.url) URL.revokeObjectURL(S.crest.url); S.crest=null; $("cb-crestfile").value=""; renderCrest(); });
  $("cb-crestbg").addEventListener("click", function(){
    if(!S.crest) return; var msg=$("cb-crestbgmsg"); if(msg) msg.textContent="Working…";
    var img=new Image(); img.onload=function(){ removeBackground(img, function(url,how){
      if(url){ S.crest.processedUrl=url; if($("cb-crestundo")) $("cb-crestundo").classList.remove("cb-hidden"); if(msg) msg.textContent="Background removed ✓"; renderCrest(); }
      else if(msg) msg.textContent = how==="already"?"Already has a transparent background.":how==="nocorner"?"No plain background found — a PNG works best.":"Couldn't process that image.";
    }); };
    img.onerror=function(){ if(msg) msg.textContent="Couldn't load that image."; };
    img.src=S.crest.url;
  });
  $("cb-crestundo").addEventListener("click", function(){ if(S.crest){ S.crest.processedUrl=null; } if($("cb-crestundo")) $("cb-crestundo").classList.add("cb-hidden"); var msg=$("cb-crestbgmsg"); if(msg) msg.textContent="Reverted."; renderCrest(); });
  if($("cb-crestsize")) $("cb-crestsize").addEventListener("input", function(){ root.style.setProperty("--crest-w", this.value+"cqw"); });
  if($("cb-crestsizeb")) $("cb-crestsizeb").addEventListener("input", function(){ root.style.setProperty("--crest-w-b", this.value+"cqw"); });
  // writing-box colour + opacity
  function hexToRgb(h){ h=(h||"#ffffff").replace("#",""); if(h.length===3) h=h.replace(/./g,"$&$&"); return [parseInt(h.substr(0,2),16),parseInt(h.substr(2,2),16),parseInt(h.substr(4,2),16)]; }
  function applyBox(){ var c=$("cb-boxcol"); if(!c) return; var rgb=hexToRgb(c.value), o=$("cb-boxop"), op=o?+o.value:1; root.style.setProperty("--box-bg","rgba("+rgb[0]+","+rgb[1]+","+rgb[2]+","+op+")"); }
  if($("cb-boxcol")) $("cb-boxcol").addEventListener("input",applyBox);
  if($("cb-boxop")) $("cb-boxop").addEventListener("input",applyBox);
  if($("cb-boxsize")) $("cb-boxsize").addEventListener("input", function(){ root.style.setProperty("--box-scale", this.value); });
  // crest drag on the front, clamped to a 5mm safe margin from the edges
  (function(){
    var crest=$("cert-crest"), front=$("cert-front"); if(!crest||!front) return;
    var cdx=0, cdy=0, d=null, MIN=100/297*5, CH=100/1.4142; // 5mm in cqw; cert height in cqw
    var spot="bl";                                                       // named position from the buttons (null once dragged/nudged)
    function crestW(){ return +($("cb-crestsize")?$("cb-crestsize").value:13); }
    function place(ndx, ndy){ var w=crestW();
      ndx=Math.max(MIN-4, Math.min(100-MIN-4-w, ndx));                 // left edge ≥5mm, right edge ≥5mm
      ndy=Math.min(3.2-MIN, Math.max(3.2+w-(CH-MIN), ndy));            // bottom edge ≥5mm, top edge ≥5mm
      cdx=ndx; cdy=ndy; crest.style.transform="translate("+cdx+"cqw,"+cdy+"cqw)"; }
    crest.addEventListener("pointerdown", function(ev){ d={px:ev.clientX,py:ev.clientY,ox:cdx,oy:cdy,w:front.getBoundingClientRect().width||700}; root.classList.add("cb-dragging"); try{ crest.setPointerCapture(ev.pointerId); }catch(_e){} ev.preventDefault(); ev.stopPropagation(); });
    crest.addEventListener("pointermove", function(ev){ if(!d) return;
      place(d.ox+(ev.clientX-d.px)/d.w*100, d.oy+(ev.clientY-d.py)/d.w*100); setSpot(null); });
    function end(){ if(!d) return; d=null; root.classList.remove("cb-dragging"); }
    crest.addEventListener("pointerup",end); crest.addEventListener("pointercancel",end);

    // position buttons (easier than dragging on a phone): 9 spots + nudge arrows. Same margins as the default spot.
    function spotXY(s){ var w=crestW();
      var x={l:0, c:(100-w)/2-4, r:92-w}[s.charAt(1)], y={b:0, m:3.2+w/2-CH/2, t:6.4+w-CH}[s.charAt(0)];
      return [x,y]; }
    var pad=$("cb-crestpos");
    function setSpot(s){ spot=s; if(pad) Array.prototype.forEach.call(pad.querySelectorAll("[data-spot]"), function(b){ b.setAttribute("aria-pressed", String(b.getAttribute("data-spot")===s)); }); }
    if(pad){
      var LABELS={tl:"Top left",tc:"Top centre",tr:"Top right",ml:"Middle left",mc:"Centre",mr:"Middle right",bl:"Bottom left",bc:"Bottom centre",br:"Bottom right"};
      var grid=document.createElement("div"); grid.className="cb-posgrid";
      ["tl","tc","tr","ml","mc","mr","bl","bc","br"].forEach(function(s){
        var b=document.createElement("button"); b.type="button"; b.setAttribute("data-spot",s); b.title=LABELS[s]; b.setAttribute("aria-label","Crest "+LABELS[s].toLowerCase());
        b.addEventListener("click", function(){ var p=spotXY(s); place(p[0],p[1]); setSpot(s); });
        grid.appendChild(b); });
      var nudge=document.createElement("div"); nudge.className="cb-nudge";
      [["←",-1,0,"left"],["↑",0,-1,"up"],["↓",0,1,"down"],["→",1,0,"right"]].forEach(function(n){
        var b=document.createElement("button"); b.type="button"; b.textContent=n[0]; b.setAttribute("aria-label","Nudge crest "+n[3]);
        b.addEventListener("click", function(){ place(cdx+n[1]*1.5, cdy+n[2]*1.5); setSpot(null); });
        nudge.appendChild(b); });
      pad.appendChild(grid); pad.appendChild(nudge); setSpot(spot);
    }
    // keep the crest in its spot (and on the certificate) when its size changes
    if($("cb-crestsize")) $("cb-crestsize").addEventListener("input", function(){ if(spot){ var p=spotXY(spot); place(p[0],p[1]); } else place(cdx,cdy); });
  })();

  /* ---------- background (grid choice + upload), fills the centre band ---------- */
  function renderBg(){
    var url = S.bgUpload ? S.bgUpload.url : (S.bgUrl || "");
    var has = !!url;
    ["cert-photo","cert-photo-b"].forEach(function(id){ var el=$(id); if(el){ el.style.backgroundImage = has?("url('"+url+"')"):""; el.classList.toggle("cb-has-bg", has); } });  // both sides
    var chip=$("cb-photochip"); if(chip) chip.classList.toggle("cb-hidden", !S.bgUpload);
    if(S.bgUpload){ var th=$("cb-photothumb"); if(th) th.src=S.bgUpload.url; var nm=$("cb-photoname"); if(nm) nm.textContent=S.bgUpload.name||"Photo"; }
  }
  var BGS = DATA.bgs || [], bgCat="All";
  (function(){ var fh=$("cb-bgfilter"); if(!fh||!BGS.length) return;
    var cats=["All"]; BGS.forEach(function(b){ if(b.cat && cats.indexOf(b.cat)<0) cats.push(b.cat); });
    if(cats.length<=1){ fh.style.display="none"; return; }
    cats.forEach(function(c){ var b=document.createElement("button"); b.type="button"; b.textContent=c; b.setAttribute("aria-pressed",String(c===bgCat)); b.addEventListener("click",function(){ bgCat=c; Array.prototype.forEach.call(fh.children,function(x){x.setAttribute("aria-pressed",String(x.textContent===c));}); drawBgGrid(); }); fh.appendChild(b); });
  })();
  function bgList(){ return BGS.filter(function(b){ return bgCat==="All"||b.cat===bgCat; }); }
  function drawBgGrid(){
    var g=$("cb-bggrid"); if(!g) return; g.innerHTML="";
    bgList().forEach(function(b){
      var el=document.createElement("button"); el.type="button"; el.className="cb-bgcell"; el.title=b.name; el.setAttribute("aria-pressed",String(!S.bgUpload && S.bgUrl===b.image));
      var im=document.createElement("img"); im.loading="lazy"; im.decoding="async"; im.alt=b.name; im.src=b.thumb||b.image; el.appendChild(im);
      el.addEventListener("click",function(){ if(S.bgUpload&&S.bgUpload.url) URL.revokeObjectURL(S.bgUpload.url); S.bgUpload=null; S.bgUrl=b.image; Array.prototype.forEach.call(g.children,function(x){x.setAttribute("aria-pressed","false");}); el.setAttribute("aria-pressed","true"); renderBg(); });
      g.appendChild(el);
    });
  }
  drawBgGrid();
  if($("cb-bgnone")) $("cb-bgnone").addEventListener("click", function(){ if(S.bgUpload&&S.bgUpload.url) URL.revokeObjectURL(S.bgUpload.url); S.bgUpload=null; S.bgUrl=null; drawBgGrid(); renderBg(); });
  $("cb-photofile").addEventListener("change", function(){
    var f=this.files&&this.files[0]; if(!f) return;
    if(S.bgUpload&&S.bgUpload.url) URL.revokeObjectURL(S.bgUpload.url);
    S.bgUpload={ name:f.name, url:URL.createObjectURL(f), file:f }; S.bgUrl=null; drawBgGrid(); renderBg();
  });
  $("cb-photoremove").addEventListener("click", function(){ if(S.bgUpload&&S.bgUpload.url) URL.revokeObjectURL(S.bgUpload.url); S.bgUpload=null; $("cb-photofile").value=""; drawBgGrid(); renderBg(); });

  /* ---------- font style ---------- */
  var FONTS=[{n:"Default",v:""},{n:"Anton",v:'"Anton"'},{n:"Bebas",v:'"Bebas Neue"'},{n:"Oswald",v:'"Oswald"'},{n:"Archivo",v:'"Archivo"'},{n:"Staatliches",v:'"Staatliches"'},{n:"Passion",v:'"Passion One"'}];
  (function(){ var fh=$("cb-fonts"); if(!fh) return;
    FONTS.forEach(function(f,i){ var b=document.createElement("button"); b.type="button"; b.className="cb-fontchip"; b.textContent=f.n; if(f.v) b.style.fontFamily=f.v+",sans-serif"; b.setAttribute("aria-pressed",String(i===0));
      b.addEventListener("click",function(){ if(f.v) root.style.setProperty("--cert-font", f.v+",sans-serif"); else root.style.removeProperty("--cert-font"); Array.prototype.forEach.call(fh.children,function(x){x.setAttribute("aria-pressed",String(x===b));}); });
      fh.appendChild(b); });
  })();

  /* ---------- front / back flip ---------- */
  function applySide(){ var back=root.classList.contains("cb-showback"); Array.prototype.forEach.call(root.querySelectorAll("[data-side]"), function(el){ el.style.display = ((back?"back":"front")===el.getAttribute("data-side")) ? "" : "none"; }); }
  function showSide(back){ root.classList.toggle("cb-showback", !!back); if($("cb-showback")) $("cb-showback").classList.toggle("is-active", !!back); if($("cb-showfront")) $("cb-showfront").classList.toggle("is-active", !back); applySide(); }
  $("cb-showfront").addEventListener("click", function(){ showSide(false); });
  $("cb-showback").addEventListener("click", function(){ showSide(true); });

  /* ---------- pack size + price ---------- */
  function money(p){ return "£"+(((p||0)/100).toFixed(2)); }
  (function buildSizes(){
    var sel=$("cb-size"); if(!sel) return;
    DATA.variants.forEach(function(v){ var o=document.createElement("option"); o.value=v.id; o.textContent=v.title+(v.available?"":" (sold out)"); sel.appendChild(o); });
    sel.addEventListener("change", updatePrice); updatePrice();
  })();
  function currentVariant(){ var sel=$("cb-size"); if(!sel) return null; var id=+sel.value; for(var i=0;i<DATA.variants.length;i++){ if(DATA.variants[i].id===id) return DATA.variants[i]; } return DATA.variants[0]||null; }
  function updatePrice(){ var v=currentVariant(); if($("cb-price")) $("cb-price").textContent = v?money(v.price):"£0.00"; if($("cb-varid")) $("cb-varid").value = v?v.id:""; if($("cb-buy")) $("cb-buy").disabled = !v; }

  /* ---------- export: 2-page A4 landscape PDF ---------- */
  function ensureJsPdf(cb){
    if(window.jspdf && window.jspdf.jsPDF){ cb(window.jspdf.jsPDF); return; }
    var src=root.getAttribute("data-jspdf"); if(!src){ cb(null); return; }
    var s=document.createElement("script"); s.src=src; s.onload=function(){ cb(window.jspdf?window.jspdf.jsPDF:null); }; s.onerror=function(){ cb(null); }; document.head.appendChild(s);
  }
  function composeCert(el, cb){
    if(typeof html2canvas!=="function"){ cb(null); return; }
    var r=el.getBoundingClientRect(), w=r.width||760;
    var scale=Math.min(4, Math.max(2, 2480/w));
    root.classList.add("cb-exporting");
    html2canvas(el, { backgroundColor:"#ffffff", scale:scale, useCORS:true, logging:false }).then(function(c){ root.classList.remove("cb-exporting"); cb(c); }).catch(function(){ root.classList.remove("cb-exporting"); cb(null); });
  }
  function imagesReady(){
    var imgs=[];
    ["cert-crest","cert-crest-b","cert-photo","cert-photo-b"].forEach(function(id){ var h=$(id); if(!h) return; var im=(h.tagName==="IMG")?h:h.querySelector("img"); if(im) imgs.push(im); });
    return Promise.all(imgs.map(function(im){
      return (im.complete && im.naturalWidth) ? Promise.resolve() : new Promise(function(res){ im.addEventListener("load",res); im.addEventListener("error",res); setTimeout(res,4000); });
    }));
  }
  function captureBoth(cb){
    var fontsReady=(document.fonts&&document.fonts.ready)?document.fonts.ready:Promise.resolve();
    var ready=fontsReady.then(function(){ return imagesReady(); });
    ready.then(function(){
      var wasBack=root.classList.contains("cb-showback");
      root.classList.remove("cb-showback");
      composeCert($("cert-front"), function(front){
        root.classList.add("cb-showback");
        composeCert($("cert-back"), function(back){
          if(!wasBack) root.classList.remove("cb-showback");
          cb(front, back);
        });
      });
    });
  }
  function buildPdf(cb){ // cb(blob)
    ensureJsPdf(function(JsPDF){
      if(!JsPDF){ cb(null); return; }
      captureBoth(function(front, back){
        if(!front){ cb(null); return; }
        try{
          var pdf=new JsPDF({ orientation:"landscape", unit:"mm", format:"a4" });
          pdf.addImage(front.toDataURL("image/jpeg",0.92), "JPEG", 0, 0, 297, 210);
          if(back){ pdf.addPage(); pdf.addImage(back.toDataURL("image/jpeg",0.92), "JPEG", 0, 0, 297, 210); }
          cb(pdf.output("blob"));
        }catch(e){ cb(null); }
      });
    });
  }

  /* ---------- loading overlay ---------- */
  function showLoading(){ var l=$("cb-loading"); if(!l) return; l.hidden=false; var f=$("cb-barfill"); if(f){ f.style.transition="none"; f.style.width="0%"; void f.offsetWidth; f.style.transition="width 3s cubic-bezier(.2,.8,.25,1)"; f.style.width="92%"; } }
  function finishLoading(cb){ var f=$("cb-barfill"); if(f){ f.style.transition="width .35s ease"; f.style.width="100%"; } setTimeout(cb,400); }
  function hideLoading(){ var l=$("cb-loading"); if(l) l.hidden=true; }

  function sanitize(s){ return String(s||"certificate").replace(/[^a-z0-9]+/gi,"-").replace(/^-+|-+$/g,"").toLowerCase()||"certificate"; }
  function attach(id, blob, name){ try{ var dt=new DataTransfer(); dt.items.add(new File([blob], name, {type:"application/pdf"})); $(id).files=dt.files; return true; }catch(e){ return false; } }
  function attachFile(id, file){ try{ var dt=new DataTransfer(); dt.items.add(file); $(id).files=dt.files; return true; }catch(e){ return false; } }

  /* ---------- add to cart ---------- */
  var form=$("cb-form");
  form.addEventListener("submit", function(e){
    if(form.__ready) return;
    e.preventDefault();
    if(!$("cb-varid").value){ alert("Please choose a pack size first."); return; }
    showLoading();
    buildPdf(function(blob){
      if(!blob){ hideLoading(); alert("Sorry — couldn't build the certificate just now. Please try again."); return; }
      attach("cb-p-design", blob, sanitize($("cb-i-heading").value)+"-certificate.pdf");
      if(S.crest && S.crest.file) attachFile("cb-p-crest", S.crest.file);
      $("cb-p-club").value = $("cb-i-heading").value||"";
      $("cb-p-name").value = ($("cb-i-name")&&$("cb-i-name").value)||"";   // handwritten — usually blank
      $("cb-p-recog").value = ($("cb-i-recog")&&$("cb-i-recog").value)||"";
      $("cb-p-date").value = ($("cb-i-date")&&$("cb-i-date").value)||"";   // handwritten — usually blank
      var _cs=getComputedStyle(root);
      var c1=$("cb-col1")?$("cb-col1").value:(_cs.getPropertyValue("--c1").trim());
      var c2=$("cb-col2")?$("cb-col2").value:(_cs.getPropertyValue("--c2").trim());
      $("cb-p-cols").value = c1+" / "+c2;
      form.__ready=true;
      finishLoading(function(){ form.submit(); });
    });
  });

  /* ---------- per-text styling: colour, size, position (drag), drop shadow, glow ---------- */
  var EL=[
    {key:"heading", drag:"cert-heading", text:"cert-heading", label:"Heading", size:7, side:"front", wordInput:"cb-i-heading"},
    {key:"name",    drag:"row-name",     text:"cert-name",    label:"Awarded to", size:3.1, side:"front", wordInput:null},
    {key:"recog",   drag:"row-recog",    text:"cert-recog",   label:"In recognition", size:3.1, side:"front", wordInput:"cb-i-recog"},
    {key:"date",    drag:"row-date",     text:"cert-date",    label:"Date", size:3.1, side:"front", wordInput:null},
    {key:"message", drag:"cert-message", text:"cert-message", label:"Message", size:6, side:"front", wordInput:"cb-i-message"}
  ];
  var EST={}; EL.forEach(function(e){ EST[e.key]={color:"", font:"", size:e.size, dx:0, dy:0, shadow:false, glow:false}; });
  var selKey=EL[0].key;
  function elBy(k){ for(var i=0;i<EL.length;i++){ if(EL[i].key===k) return EL[i]; } return EL[0]; }
  function tshadow(s){ var p=[]; if(s.shadow) p.push("0 0.4cqw 0.7cqw rgba(0,0,0,.6)"); if(s.glow) p.push("0 0 1.6cqw rgba(255,255,255,.9)"); return p.length?p.join(","):"none"; }
  function applyEl(e){
    var st=EST[e.key], txt=$(e.text), dg=$(e.drag);
    if(txt){ txt.style.color=st.color||""; txt.style.fontFamily=st.font?(st.font+",sans-serif"):""; txt.style.fontSize=st.size+"cqw"; txt.style.textShadow=(st.shadow||st.glow)?tshadow(st):""; }
    if(dg){ dg.style.transform=(st.dx||st.dy)?("translate("+st.dx+"cqw,"+st.dy+"cqw)"):""; }
  }
  function applyAll(){ EL.forEach(applyEl); }
  function outlineSel(){ EL.forEach(function(e){ var dg=$(e.drag); if(dg) dg.classList.toggle("cert-sel", e.key===selKey); }); }
  function rgbToHex(rgb){ var m=/rgba?\((\d+),\s*(\d+),\s*(\d+)/.exec(rgb||""); if(!m) return "#ffffff"; function h(n){ n=(+n).toString(16); return n.length<2?"0"+n:n; } return "#"+h(m[1])+h(m[2])+h(m[3]); }
  function cbLabel(t){ var l=document.createElement("label"); l.className="cb-lb"; l.textContent=t; return l; }
  function cbToggle(label,val,fn){ var t=document.createElement("div"); t.className="cb-toggle"; t.innerHTML='<span class="t"></span><button class="cb-switch" type="button" aria-pressed="'+String(!!val)+'"></button>'; t.querySelector(".t").textContent=label; t.querySelector(".cb-switch").addEventListener("click",function(){ var on=this.getAttribute("aria-pressed")!=="true"; this.setAttribute("aria-pressed",String(on)); fn(on); }); return t; }
  function buildElEditor(){
    var host=$("cb-eleditor"); if(!host) return; host.innerHTML="";
    var e=elBy(selKey), st=EST[selKey];
    host.appendChild(cbLabel("Colour"));
    var crow=document.createElement("div");
    var col=document.createElement("input"); col.type="color"; col.value=st.color||rgbToHex(getComputedStyle($(e.text)).color);
    col.addEventListener("input",function(){ st.color=this.value; applyEl(e); });
    var reset=document.createElement("button"); reset.type="button"; reset.className="cb-resetcol"; reset.textContent="reset";
    reset.addEventListener("click",function(){ st.color=""; applyEl(e); buildElEditor(); });
    crow.appendChild(col); crow.appendChild(reset); host.appendChild(crow);
    host.appendChild(cbLabel("Font"));
    var fsel=document.createElement("select"); fsel.className="cb-input";
    FONTS.forEach(function(f){ var o=document.createElement("option"); o.value=f.v; o.textContent=f.n; if(f.v) o.style.fontFamily=f.v+",sans-serif"; if((st.font||"")===f.v) o.selected=true; fsel.appendChild(o); });
    fsel.addEventListener("change",function(){ st.font=this.value; applyEl(e); });
    host.appendChild(fsel);
    host.appendChild(cbLabel("Size"));
    var sz=document.createElement("input"); sz.type="range"; sz.className="cb-range"; sz.min="1.5"; sz.max="12"; sz.step="0.1"; sz.value=st.size;
    sz.addEventListener("input",function(){ st.size=+this.value; applyEl(e); }); host.appendChild(sz);
    host.appendChild(cbToggle("Drop shadow", st.shadow, function(v){ st.shadow=v; applyEl(e); }));
    host.appendChild(cbToggle("Glow", st.glow, function(v){ st.glow=v; applyEl(e); }));
  }
  /* floating mini-toolbar on the selected text */
  function popMini(label,fn){ var b=document.createElement("button"); b.type="button"; b.className="cb-pop-mini"; b.textContent=label; b.addEventListener("click",function(ev){ ev.stopPropagation(); fn.call(b); }); return b; }
  function buildPop(){
    var pop=$("cb-pop"); if(!pop) return; pop.innerHTML="";
    var e=elBy(selKey), st=EST[selKey], txt=$(e.text);
    var r1=document.createElement("div"); r1.className="cb-pop-row";
    var ti=document.createElement("input"); ti.className="cb-pop-text"; ti.type="text"; ti.placeholder=(e.wordInput?"Type text…":"Type here, or leave blank to handwrite"); ti.value=txt?txt.textContent:"";
    ti.addEventListener("input",function(){ if(txt) txt.textContent=this.value; if(e.wordInput && $(e.wordInput)) $(e.wordInput).value=this.value; });
    r1.appendChild(ti); pop.appendChild(r1);
    var r2=document.createElement("div"); r2.className="cb-pop-row";
    var col=document.createElement("input"); col.type="color"; col.className="cb-pop-col"; col.title="Colour"; col.value=st.color||rgbToHex(getComputedStyle(txt).color);
    col.addEventListener("input",function(){ st.color=this.value; applyEl(e); }); r2.appendChild(col);
    var fsel=document.createElement("select"); fsel.className="cb-pop-font"; fsel.title="Font";
    FONTS.forEach(function(f){ var o=document.createElement("option"); o.value=f.v; o.textContent=f.n; if(f.v) o.style.fontFamily=f.v+",sans-serif"; if((st.font||"")===f.v) o.selected=true; fsel.appendChild(o); });
    fsel.addEventListener("change",function(){ st.font=this.value; applyEl(e); }); r2.appendChild(fsel);
    r2.appendChild(popMini("A−",function(){ st.size=Math.max(1.5,+(st.size-0.4).toFixed(1)); applyEl(e); }));
    r2.appendChild(popMini("A+",function(){ st.size=Math.min(14,+(st.size+0.4).toFixed(1)); applyEl(e); }));
    var sh=popMini("Shadow",function(){ st.shadow=!st.shadow; this.classList.toggle("on",st.shadow); applyEl(e); }); sh.classList.toggle("on",st.shadow); r2.appendChild(sh);
    var gl=popMini("Glow",function(){ st.glow=!st.glow; this.classList.toggle("on",st.glow); applyEl(e); }); gl.classList.toggle("on",st.glow); r2.appendChild(gl);
    pop.appendChild(r2);
  }
  function positionPop(){
    var pop=$("cb-pop"); if(!pop||pop.hidden) return;
    var e=elBy(selKey), el=$(e.drag); if(!el) return;
    var stage=el.closest(".cb-stage"); if(!stage) return;
    var er=el.getBoundingClientRect(), sr=stage.getBoundingClientRect(), pr=pop.getBoundingClientRect();
    var left=(er.left-sr.left)+er.width/2-pr.width/2, top=(er.top-sr.top)-pr.height-10;
    if(top<4) top=(er.bottom-sr.top)+10;
    left=Math.max(6, Math.min(sr.width-pr.width-6, left));
    pop.style.left=left+"px"; pop.style.top=Math.max(4,top)+"px";
  }
  function showPop(){ var pop=$("cb-pop"); if(!pop) return; buildPop(); pop.hidden=false; positionPop(); }
  function hidePop(){ var pop=$("cb-pop"); if(pop) pop.hidden=true; }
  document.addEventListener("click", function(ev){
    var pop=$("cb-pop"); if(!pop||pop.hidden) return;
    if(ev.target.closest && (ev.target.closest("#cb-pop") || ev.target.closest(".cert-front .cert-heading,.cert-front .cert-message,.cert-front .cert-row") || ev.target.closest(".cb-elchip"))) return;
    hidePop();
  });
  window.addEventListener("resize", positionPop);
  function selectEl(k){ selKey=k; var e=elBy(k); showSide(e.side==="back");
    var host=$("cb-elpick"); if(host) Array.prototype.forEach.call(host.children,function(c){ c.setAttribute("aria-pressed",String(c.getAttribute("data-el")===k)); }); outlineSel(); buildElEditor(); showPop(); }
  (function(){ var host=$("cb-elpick"); if(!host) return;
    EL.forEach(function(e){ var b=document.createElement("button"); b.type="button"; b.className="cb-elchip"; b.textContent=e.label; b.setAttribute("data-el",e.key); b.setAttribute("aria-pressed",String(e.key===selKey)); b.addEventListener("click",function(){ selectEl(e.key); }); host.appendChild(b); });
  })();
  (function(){ // click any text (front or back) to select & edit it — positions are now fixed (no dragging)
    function hit(target){ var node=target.closest(".cert-row,.cert-heading,.cert-message,.cert-back-name"); if(!node) return null; for(var i=0;i<EL.length;i++){ if($(EL[i].drag)===node) return EL[i]; } return null; }
    function down(ev){ var e=hit(ev.target); if(!e) return; selectEl(e.key); }
    ["cert-front","cert-back"].forEach(function(id){ var el=$(id); if(!el) return; el.addEventListener("pointerdown",down); });
  })();
  applyAll(); outlineSel(); buildElEditor();

  renderCrest(); renderBg(); applySide();
})();
